import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UIModule } from '../../shared/ui';
import { ButtonComponent, buttonResolver } from './button.component';

const MODULES = [CommonModule, UIModule];

const DECLARATIONS = [ButtonComponent];

@NgModule({
  declarations: [...DECLARATIONS],
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
})
export class ButtonModule {
  static entry = ButtonComponent;
  static componentDataResolver = buttonResolver;
}
